import React, { useState } from 'react';
import { MdOutlineDescription } from 'react-icons/md';
import { SectionCard, Note } from './ui';

const CLAMP_CHARS = 520;

export default function DescriptionCard({ data, status }) {
  const [expanded, setExpanded] = useState(false);
  const description = data?.description || null;
  const summary = data?.description_summary || null;
  const long = description && description.length > CLAMP_CHARS;
  const shown = long && !expanded ? `${description.slice(0, CLAMP_CHARS).trimEnd()}…` : description;

  return (
    <SectionCard id="le-section-description" icon={<MdOutlineDescription size={20} />} title="Listing description" subtitle={description ? 'Source text as listed' : null} status={status} dataset={data}>
      {data ? (
        (description || summary) ? (
          <>
            {summary ? <p className="le-description-summary">{summary}</p> : null}
            {description ? (
              <>
                <p className="le-description-text">{shown}</p>
                {long ? (
                  <button type="button" className="le-link-btn" onClick={() => setExpanded((e) => !e)}>
                    {expanded ? 'Show less' : 'Show full description'}
                  </button>
                ) : null}
              </>
            ) : null}
          </>
        ) : (
          <Note tone="muted">No listing description is on record for this property.</Note>
        )
      ) : null}
    </SectionCard>
  );
}
